<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiBellOffOutline } from "@mdi/js";
export default {
  name: "MdiBellOffOutline",
  data() {
    return {
      svgPath: mdiBellOffOutline,
    };
  },
};
</script>
